<template>
  <img src="/img/logo.png" width="80px" alt="Logo" />
</template>
